import { Slide } from "@jelly/lesson";

import { task as task03 } from "../../../../../task/course-02/lesson-13/task-03";

const task: Slide = {
  titleHtml: "Match the HRIRs to the correct sound source location.",
  description: "Connect with lines.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task03.id,
        },
      },
    },
  },
};

export default task;
